import { createAsyncThunk } from '@reduxjs/toolkit';
import { TransactionDocuments } from '../../../../models/TransactionDocuments/transaction-documents.model';

export const GetTransactionDocuments = createAsyncThunk(
    'transactionDocuments/getTransactionDocuments',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.get(
            `/api/Marketplace/Engagements/${engagementId}/TransactionDocuments`
        );

        if (response.status !== 200) {
            throw new Error('Failed to fetch the transaction documents');
        }

        return response.data as TransactionDocuments;
    }
);
